"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPortalServiceImpl = void 0;
const rxjs_1 = require("rxjs");
const core_1 = require("@athena-portal/core");
const operators_1 = require("rxjs/operators");
const Types_1 = require("../../Types");
const model_1 = require("../../model");
const Cache_1 = require("../../decorators/Cache");
const EnumPolicyFilter_1 = require("./EnumPolicyFilter");
const __1 = require("../..");
/**
 * Rest implementation of the example service
 */
let CustomerPortalServiceImpl = class CustomerPortalServiceImpl extends core_1.RestService {
    constructor(configuration, notificationService) {
        super();
        this.configuration = configuration;
        this.notificationService = notificationService;
    }
    getProfile() {
        return this.doRequest(`/profile`);
    }
    getProfileForMarketingPreferences() {
        return super.getProtectedResource({
            method: "GET",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}/profile`,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)((err) => {
            if (err.status === 404) {
                return (0, rxjs_1.of)(undefined);
            }
            return (0, rxjs_1.throwError)(err);
        }));
    }
    getPolicies(product, filter, onlyCurrentPeriodPolicyVersions = false) {
        const searchParams = new URLSearchParams();
        if (product) {
            searchParams.append("product", product);
        }
        if (filter) {
            searchParams.append("filter", EnumPolicyFilter_1.EnumPolicyFilter[filter]);
        }
        searchParams.append("onlyCurrentPeriodPolicyVersions", onlyCurrentPeriodPolicyVersions.toString());
        return this.doRequest(`/flow-policies?${searchParams.toString()}`, "GET");
    }
    getExpiredPolicies(product) {
        const searchParams = new URLSearchParams();
        if (product) {
            searchParams.append("product", product);
        }
        return this.doRequest(`/flow-policies/expired?${searchParams.toString()}`, "GET");
    }
    getMinOrMaxFutureMtaDate() {
        return this.doRequest(`/flow-policies/get-min-or-max-future-mta-date`, "GET");
    }
    mtaIsPresentForMultiplePolicies() {
        return this.doRequest(`/flow-policies/is-mta-preset-for-multiple-policies`, "GET");
    }
    accountHasPolicyWith24hOldMTA() {
        return this.doRequest('/flow-policies/account-has-policy-with-24-h-old-mta', "GET");
    }
    policyHas24hOldMTA(policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest(`/flow-policies/policy-has-24-h-old-mta?${searchParams.toString()}`);
    }
    getFutureMtaCount() {
        return this.doRequest(`/flow-policies/future-mta-count`, "GET");
    }
    getPoliciesByPolicyVersionId(policyVersionId) {
        return this.doRequest(`/policyVersions/${policyVersionId}`);
    }
    getPolicy(policyNumber) {
        return this.doRequest(`/policies/${policyNumber}`);
    }
    getUserPoliciesWithLatestVersions() {
        return this.getPolicies();
    }
    isAllianzPromotion() {
        return this.doRequest(`/flow-policies/is-allianz-promotion`, "GET");
    }
    getAllDocuments() {
        return this.doRequest(`/documents`, "GET");
    }
    getSms(policyNumber) {
        return this.doRequest(`/policies/${policyNumber}/sms`, "GET");
    }
    getPolicyDocuments(policyNumber) {
        return this.doRequest(`/policies/${policyNumber}/documents`, "GET");
    }
    getPolicyDocumentsByPolicyVersionId(policyNumber, policyVersionId) {
        return this.doRequest(`/policies/${policyNumber}/policyVersion/${policyVersionId}/documents`, "GET");
    }
    getPostRequestedDocuments(policyNumber) {
        return this.doRequest(`/documents/postRequest/${policyNumber}/getPostRequestedDocuments`, "GET");
    }
    setDocumentsRequestedByPost(documentIds, policyNumber) {
        return this.doRequest(`/documents/postRequest/setDocumentsRequestedByPost`, "POST", {
            documentIds,
            policyNumber,
        });
    }
    getQuotes() {
        return this.doRequest(`/quotes/active`, "GET");
    }
    getQuoteDocuments(quoteNumber) {
        return this.doRequest(`/quotes/${quoteNumber}/documents`, "GET");
    }
    getDocumentWithContent(documentId) {
        return this.doRequest(`/documents/${documentId}`);
    }
    downloadDocument(documentId) {
        const _this = this;
        this.requestModifiers.push(new class {
            modifyHttpRequest(request) {
                request.headers = request.headers || {};
                request.headers.Accept = "application/octet-stream";
                request.responseType = "blob";
                return _this.applicationGuard.modifyHttpRequest(request);
            }
        });
        return this.doRequest(`/documents/${documentId}/download`);
    }
    getPolicyHistory() {
        return this.doRequest(`/policies/history`, "GET");
    }
    getValuableItemsWithStartDates() {
        return this.doRequest(`/onlineClaims/valuables`, "GET");
    }
    updatePartyProperty(key, value) {
        return this.doRequest(`/profile/property`, "POST", {
            key,
            value
        });
    }
    getPartyPropertyByPropertyKey(propertyKey) {
        return this.doRequest(`/profile/property/${propertyKey}`, "GET");
    }
    updateMarketingPreferences(preferences) {
        return this.doRequest(`/profile/marketing-preferences`, "POST", preferences);
    }
    getPolicyPropertiesByPropertyKeys(policyNumber, propertyKeys) {
        return this.doRequest(`/profile/policy/properties/${policyNumber}`, "POST", propertyKeys);
    }
    getPolicyPremiumTypeByPolicyNumber(policyNumber) {
        return this.doRequest(`/profile/policy/premiumType/${policyNumber}`, "get");
    }
    getPolicyPaymentTypeByPolicyNumber(policyNumber) {
        return this.doRequest(`/profile/policy/paymentType/${policyNumber}`, "get");
    }
    isMonthlyPayerInCurrentPeriod(policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest(`/flow-policies/is-monthly-payer?${searchParams.toString()}`, "GET");
    }
    updateUser(user) {
        return super.getProtectedResource({
            body: user,
            method: "POST",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}/profile`,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(err);
        }));
    }
    validateNewCard(reuseCard, policyNumber) {
        if (policyNumber) {
            // annual products
            return this.doRequest(`/profile/card/validate/${policyNumber}/?reuseCard=true`);
        }
        else {
            // subscription products
            return this.doRequest(`/profile/card/validate/?reuseCard=${reuseCard}`);
        }
    }
    verifyNewCard(paymentReference, reuseCard, annualCard, policyNumber) {
        if (policyNumber) {
            // annual products
            return this.doRequest(`/profile/card/verify/${paymentReference}/annualCard/${annualCard}/${policyNumber}?reuseCard=${reuseCard}`);
        }
        else {
            // subscription products
            return this.doRequest(`/profile/card/verify/${paymentReference}/annualCard/${annualCard}?reuseCard=${reuseCard}`);
        }
    }
    autNewCardMissedPaymentByPolicyNumber(product, policyNumber) {
        return this.doRequest(`/profile/card/missed-payment/product/${product}/${policyNumber}`);
    }
    autNewCardMissedPaymentByPolicyNumberForInvoiceId(product, policyNumber, invoiceId) {
        return this.doRequest(`/profile/card/missed-payment/product/${product}/${policyNumber}/${invoiceId}`);
    }
    autNewCardOutstandingPaymentByPolicyNumber(product, policyNumber) {
        return this.doRequest(`/profile/card/outstanding-payment/product/${product}/${policyNumber}`);
    }
    verifyNewCardAndCompleteMissedOrOutstandingPaymentByPolicyNumber(policyNumber, request) {
        return this.doRequest(`/profile/card/verify-missed-or-outstanding-payment/${policyNumber}`, 'POST', request);
    }
    completeMissedPaymentWithMainPaymentCard(product, policyNumber) {
        return this.doRequest(`/profile/card/verify-missed-payment-existing-card/product/${product}/${policyNumber}`, "POST");
    }
    completeMissedPaymentWithMainPaymentCardForInvoice(product, policyNumber, invoiceId) {
        return this.doRequest(`/profile/card/verify-missed-payment-existing-card/product/${product}/${policyNumber}/${invoiceId}`, "POST");
    }
    completeOutstandingPaymentWithMainPaymentCard(product, policyNumber) {
        return this.doRequest(`/profile/card/verify-outstanding-payment-existing-card/product/${product}/${policyNumber}`, "POST");
    }
    changeCardReuseSetting(cardId, reuseCard, policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("reuseCard", reuseCard.toString());
        if (policyNumber) {
            searchParams.append("policyNumber", policyNumber);
        }
        return this.doRequest(`/profile/card/${cardId}/reuse?${searchParams.toString()}`, "POST");
    }
    getUserById() {
        return this.doRequest(`/profile/party`);
    }
    hasIdp() {
        return this.doRequest(`/profile/hasIdp`);
    }
    getPaymentHistory() {
        return this.doRequest(`/payments/history`);
    }
    getPaymentHistoryByPolicyNumber(policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest(`/payments/history/policy_number?${searchParams.toString()}`);
    }
    // get payment history for current period (from the latest renewal or from policy start if there is no renewal)
    getPaymentHistoryCurrentPeriod(policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest(`/payments/history/current_period?${searchParams.toString()}`);
    }
    // get payment history for past period (until the latest renewal or until policy end if there is no renewal)
    getPaymentHistoryPastPeriod(policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest(`/payments/history/past_period?${searchParams.toString()}`);
    }
    getSubscription() {
        return this.doRequest("/profile/subscription");
    }
    getAnnualPolicyInfo(policyNumber) {
        return this.doRequest(`/profile/annualPolicyInfo/${policyNumber}`);
    }
    getOptionalExtrasInformation(policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest(`/profile/optionalExtrasInformation?${searchParams.toString()}`);
    }
    getCoverChanges(policyNumber) {
        const searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest(`/profile/coverChanges?${searchParams.toString()}`);
    }
    updateValuableItem(request) {
        return this.doRequest("/valuables", "POST", request);
    }
    getValuableItemImages(itemId) {
        return this.doRequest(`/valuables/${itemId}/images`, "GET");
    }
    createValuableItemImage(request) {
        return this.doRequest("/valuables/images", "POST", request);
    }
    createOnlineRentersClaimRequest(request) {
        return this.doRequest("/onlineClaims/renters", "POST", request);
    }
    createOnlineMotorClaimRequest(request) {
        return this.doRequest("/onlineClaims/motor", "POST", request);
    }
    deleteValuableItemImage(imageId) {
        return this.doRequest(`/valuables/images/${imageId}`, "DELETE");
    }
    getOnlineClaims() {
        return this.doRequest("/onlineClaims/claims");
    }
    getSettledAmountByPaymentReference(paymentReference) {
        return this.doRequest(`/profile/payments/${paymentReference}/amount`, "GET");
    }
    getInstalmentsInfo(policyVersionId) {
        return this.doRequest(`/profile/payments/${policyVersionId}/instalmentsInfo`);
    }
    getInstalmentsInfoByAgreementNumber(agreementNumber) {
        return this.doRequest(`/payment/${agreementNumber}/instalmentsInfo`);
    }
    getMissedPaymentInfo(policyVersionId) {
        return this.doRequest(`/profile/payments/${policyVersionId}/missedPaymentInfo`);
    }
    getCombinedInstalmentsInfo(agreementVersionIds) {
        let queryString = "agreementVersionIds=";
        for (let i = 0; i < agreementVersionIds.length; i++) {
            queryString += agreementVersionIds[i];
            if (i < agreementVersionIds.length - 1) {
                queryString += ",";
            }
        }
        return this.doRequest(`/profile/payments/instalmentsInfo?${queryString}`, "GET");
    }
    getCombinedInstalmentsInfoByPolicyNumber(policyNumber) {
        const queryString = "policyNumber=" + policyNumber;
        return this.doRequest(`/profile/payments/instalmentsInfoByAgreementNumber?${queryString}`, "GET");
    }
    getEmailHistory() {
        return this.doRequest(`/profile/emails`, "GET");
    }
    getWolfEmailHistory() {
        return this.doRequest(`/profile/emails/wolf`, "GET");
    }
    existingCardPayment(request) {
        return this.doRequest("/payment/existing-card-payment", "POST", request);
    }
    getPaymentAmount(invoiceType) {
        return this.doRequest(`/payment/amount?invoiceType=${invoiceType}`);
    }
    newCardPaymentStart(request, policyNumber) {
        return this.doRequest(`/payment/new-card-payment-start/${policyNumber}`, "POST", request);
    }
    newCardPaymentVerify(request, paymentReference) {
        return this.doRequest(`/payment/new-card-payment-verify/${paymentReference}`, "POST", request);
    }
    constructTrustPilotReviewUrlForAnnualMotor(referenceNumber) {
        return this.doRequest("/trustpilot/construct-review-url-annual-motor", "POST", { referenceNumber });
    }
    constructTrustPilotReviewUrlForAnnualHome(referenceNumber) {
        return this.doRequest("/trustpilot/construct-review-url-annual-home", "POST", { referenceNumber });
    }
    createReviewRequest(policyNumber) {
        return this.doRequest("/trustpilot/create-review", "POST", { policyNumber });
    }
    putOnHoldReviewRequest(referenceNumber) {
        return this.doRequest("/trustpilot/hold-review", "POST", { referenceNumber });
    }
    activateReviewRequests(policyNumber) {
        return this.doRequest(`/trustpilot/activate-review/${policyNumber}`, "POST", {});
    }
    increaseReviewRequestAttemptCount(referenceNumber) {
        return this.doRequest("/trustpilot/inc-attempt-count", "POST", { referenceNumber });
    }
    getReviewRequest(policyNumber) {
        return this.doRequest(`/trustpilot/get-review/${policyNumber}`, "GET");
    }
    storePolicyAutomaticRenewalCancellationReason(agreementNumber, cancellationReason) {
        return this.doRequest(`/renewals/store-automatic-policy-renewal-cancellation-reason/${agreementNumber}`, 'POST', cancellationReason);
    }
    storePolicyAutomaticRenewalFlag(agreementNumber, value) {
        return this.doRequest(`/renewals/store-automatic-policy-renewal-flag/${agreementNumber}`, 'POST', value.toString());
    }
    storePolicyPerformRenewalFlag(agreementNumber, value) {
        return this.doRequest(`/renewals/store-policy-perform-renewal-flag/${agreementNumber}`, 'POST', value.toString());
    }
    storePaymentDay(agreementNumber, value) {
        return this.doRequest(`/profile/policy/${agreementNumber}/update-payment-day`, 'POST', value.toString());
    }
    storeAnnualToMonthlyPaymentDay(agreementNumber, value) {
        return this.doRequest(`/profile/policy/${agreementNumber}/update-annual-to-monthly-payment-day`, 'POST', value.toString());
    }
    getRenewalProposal(agreementNumber) {
        return this.doRequest(`/renewals/proposal/${agreementNumber}`, "GET");
    }
    payOffBalance(request, agreementNumber) {
        return this.doRequest(`/payment/${agreementNumber}/pay-off-balance`, "POST", request);
    }
    payOffBalanceWithNewCard(request, agreementNumber, paymentReference, reuseCard) {
        return this.doRequest(`/payment/${agreementNumber}/pay-off-balance-new-card/${paymentReference}?reuseCard=${reuseCard}`, "POST", request);
    }
    getPolicyHistoryAfterRenewal() {
        return this.doRequest(`/flow-policies/policy-history-after-renewal`, "GET");
    }
    getPolicyPropertyByPropertyKey(policyNumber, propertyKey) {
        return this.doRequest(`/profile/policy_property/${policyNumber}/${propertyKey}`, "GET");
    }
    getPolicyVersionPropertiesByPropertyKeys(policyNumber, propertyKeys) {
        return this.doRequest(`/profile/policy/properties/version/${policyNumber}`, "POST", propertyKeys);
    }
    getDocumentByNameAndPolicyNumber(policyNumber, documentName) {
        return this.doRequest(`/documents/${policyNumber}/${documentName}/`, "GET");
    }
    getMainPaymentCard(policyNumber) {
        return this.doRequest(`/profile/card/main/${policyNumber}`, 'GET');
    }
    updateDirectDebitPayment(policyNumber, request) {
        return super.getProtectedResource({
            body: request,
            method: "POST",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}/profile/policy/${policyNumber}/edit-direct-debit`,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(err);
        }));
    }
    updateDirectDebitRefund(policyNumber, request) {
        return super.getProtectedResource({
            body: request,
            method: "POST",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}/profile/policy/${policyNumber}/edit-direct-debit-refund`,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(err);
        }));
    }
    getInstalmentInfoPreview(policyNumber, paymentDay) {
        return this.doRequest(`/profile/policy/${policyNumber}/preview-payment-day/${paymentDay.toString()}`, 'GET');
    }
    getAvailablePaymentDays(policyNumber) {
        return this.doRequest(`/profile/policy/${policyNumber}/available-payment-days`, 'GET');
    }
    isApplicableForPaymentDayChange(policyNumber) {
        return this.doRequest(`/profile/policy/${policyNumber}/payment-day-change-allowed`, 'GET');
    }
    hasFailedCardRefundAndApplicableForDD(policyNumber) {
        return this.doRequest(`/refund/${policyNumber}/has-failed-card-refund-applicable-for-dd`, 'GET');
    }
    doRequest(urlAppend, method, body) {
        return super.getProtectedResource({
            body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}${urlAppend}`,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
};
exports.CustomerPortalServiceImpl = CustomerPortalServiceImpl;
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getProfile", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number, Boolean]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPolicies", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getExpiredPolicies", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getMinOrMaxFutureMtaDate", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "mtaIsPresentForMultiplePolicies", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "accountHasPolicyWith24hOldMTA", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "policyHas24hOldMTA", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getFutureMtaCount", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPoliciesByPolicyVersionId", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPolicy", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getAllDocuments", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPolicyDocuments", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPolicyDocumentsByPolicyVersionId", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getQuotes", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getQuoteDocuments", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getDocumentWithContent", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPolicyHistory", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getValuableItemsWithStartDates", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getUserById"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "updatePartyProperty", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getUserById"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPartyPropertyByPropertyKey", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getUserById"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.MarketingPreference]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "updateMarketingPreferences", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getUserById"),
    (0, Cache_1.ClearCache)("getPolicy"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.FalconUser]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "updateUser", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "validateNewCard", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getPolicyPropertyByPropertyKey"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean, Boolean, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "verifyNewCard", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "autNewCardMissedPaymentByPolicyNumber", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "autNewCardMissedPaymentByPolicyNumberForInvoiceId", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "autNewCardOutstandingPaymentByPolicyNumber", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getSubscription"),
    (0, Cache_1.ClearCache)("getPolicyDocuments"),
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    (0, Cache_1.ClearCache)("getPolicy"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, model_1.MissedPayment]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "verifyNewCardAndCompleteMissedOrOutstandingPaymentByPolicyNumber", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getSubscription"),
    (0, Cache_1.ClearCache)("getPolicyDocuments"),
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    (0, Cache_1.ClearCache)("getPolicy"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "completeMissedPaymentWithMainPaymentCard", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getSubscription"),
    (0, Cache_1.ClearCache)("getPolicyDocuments"),
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    (0, Cache_1.ClearCache)("getPolicy"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "completeMissedPaymentWithMainPaymentCardForInvoice", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getSubscription"),
    (0, Cache_1.ClearCache)("getPolicyDocuments"),
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    (0, Cache_1.ClearCache)("getPolicy"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "completeOutstandingPaymentWithMainPaymentCard", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    (0, Cache_1.ClearCache)("getPolicyPropertyByPropertyKey"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Boolean, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "changeCardReuseSetting", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getSubscription", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getAnnualPolicyInfo", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getOptionalExtrasInformation", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getCoverChanges", null);
__decorate([
    (0, Cache_1.ClearCache)("getPolicies"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.ValuableItemRequest]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "updateValuableItem", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getValuableItemImages", null);
__decorate([
    (0, Cache_1.ClearCache)("getValuableItemImages"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.ImageRequest]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "createValuableItemImage", null);
__decorate([
    (0, Cache_1.ClearCache)("getValuableItemImages"),
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getUserById"),
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getOnlineClaims"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.OnlineRentersClaimRequest]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "createOnlineRentersClaimRequest", null);
__decorate([
    (0, Cache_1.ClearCache)("getValuableItemImages"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "deleteValuableItemImage", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getOnlineClaims", null);
__decorate([
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getSettledAmountByPaymentReference", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getInstalmentsInfoByAgreementNumber", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getEmailHistory", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getWolfEmailHistory", null);
__decorate([
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.FalconPaymentRequest]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "existingCardPayment", null);
__decorate([
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getAnnualPolicyInfo"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.FalconPaymentRequest, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "newCardPaymentVerify", null);
__decorate([
    (0, Cache_1.ClearCache)("getPolicies"),
    (0, Cache_1.ClearCache)("getRenewalProposal"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, model_1.RenewalCancellationReasonRequest]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "storePolicyAutomaticRenewalCancellationReason", null);
__decorate([
    (0, Cache_1.ClearCache)("getRenewalProposal"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "storeAnnualToMonthlyPaymentDay", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getRenewalProposal", null);
__decorate([
    (0, Cache_1.ClearCache)("getInstalmentsInfoByAgreementNumber"),
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    (0, Cache_1.ClearCache)("getPaymentHistoryCurrentPeriod"),
    (0, Cache_1.ClearCache)("getPaymentHistoryPastPeriod"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.FalconPaymentRequest, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "payOffBalance", null);
__decorate([
    (0, Cache_1.ClearCache)("getInstalmentsInfoByAgreementNumber"),
    (0, Cache_1.ClearCache)("getPaymentHistory"),
    (0, Cache_1.ClearCache)("getPaymentHistoryByPolicyNumber"),
    (0, Cache_1.ClearCache)("getPaymentHistoryCurrentPeriod"),
    (0, Cache_1.ClearCache)("getPaymentHistoryPastPeriod"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.FalconPaymentRequest, String, String, Boolean]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "payOffBalanceWithNewCard", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getPolicyPropertyByPropertyKey", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], CustomerPortalServiceImpl.prototype, "getDocumentByNameAndPolicyNumber", null);
exports.CustomerPortalServiceImpl = CustomerPortalServiceImpl = __decorate([
    (0, core_1.injectable)(),
    __param(0, (0, core_1.inject)(Types_1.Types.CustomerPortalServiceConfig)),
    __param(1, (0, core_1.inject)(Types_1.Types.NotificationService)),
    __metadata("design:paramtypes", [Object, Object])
], CustomerPortalServiceImpl);
//# sourceMappingURL=CustomerPortalServiceImpl.js.map